<script setup lang="ts">
const props = defineProps({
  loading: { type: Boolean },
  disabled: { type: Boolean }
})

const emit = defineEmits(["click"])

function onClick(event: PointerEvent) {
  if (!props.disabled) {
    emit("click", event)
  }
}
</script>

<template>
  <button
    class="interface-button"
    :class="{ disabled }"
    @click="onClick"
  >
    <div class="interface-button-inner">
      <interface-spinner
        v-if="loading"
        class="interface-button-spinner"
      />
      <slot v-else name="icon" />
      <slot />
    </div>
  </button>
</template>

<style lang="sass" scoped>
.interface-button
  @apply flex items-center justify-center rounded-[#{$menu-br-input}]
  &.disabled
    @apply cursor-not-allowed opacity-50

.interface-button-inner
  @apply flex items-center justify-center gap-1

.interface-button-spinner
  @apply h-4 w-4
</style>
